import { render } from "./SponsorsSection.vue?vue&type=template&id=6d50388a&scoped=true"
import script from "./SponsorsSection.vue?vue&type=script&lang=js"
export * from "./SponsorsSection.vue?vue&type=script&lang=js"

import "./SponsorsSection.vue?vue&type=style&index=0&id=6d50388a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d50388a"]])

export default __exports__